module.exports = "//static.hsappstatic.net/salesImages/static-1.403/email-images/autolog@3x.png"